import { render, staticRenderFns } from "./BoxColecao.vue?vue&type=template&id=35ed9e7c&scoped=true&"
import script from "./BoxColecao.vue?vue&type=script&lang=js&"
export * from "./BoxColecao.vue?vue&type=script&lang=js&"
import style0 from "./BoxColecao.vue?vue&type=style&index=0&id=35ed9e7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ed9e7c",
  null
  
)

export default component.exports